var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datepicker',{attrs:{"placeholder":_vm.trans('general.ddMMyyyy'),"format":"dd.MM.yyyy","language":_vm.translations,"monday-first":true,"disabled-dates":_vm.disabledDateRange},on:{"input":function($event){return _vm.$emit('removeerror')}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }